"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploaderButton = void 0;
var _react = require("react");
var _Button = require("../../Button");
var _Uploader = require("../Uploader.labels");
var _hooks = require("../../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
const UploaderButton = exports.UploaderButton = /*#__PURE__*/(0, _react.forwardRef)((props, fileInputRef) => {
  const {
    children,
    onClick,
    onFileChange,
    styles,
    inputAcceptanceTypes,
    errorMessage,
    ...rest
  } = props;
  const getLabel = (0, _hooks.useLabels)({
    labels: _Uploader.labels
  });
  if (!onClick) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
      id: "ccUploadButton",
      ...rest,
      onClick: onClick,
      children: children
    }), errorMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Uploader__error'],
      children: errorMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      ref: fileInputRef,
      type: "file",
      className: styles['cc-Uploader__hidden-input'],
      accept: inputAcceptanceTypes,
      onChange: onFileChange,
      "aria-label": getLabel('upload_file')
    })]
  });
});